import { createContext, useContext } from 'react'

export const OrganizationContext = createContext({})
export const UseOrganizationContext = () => useContext(OrganizationContext)

export const UserContext = createContext({})
export const UseUserContext = () => useContext(UserContext)

export const ErrorContext = createContext({})
export const UseErrorContext = () => useContext(ErrorContext)